import styled from 'styled-components';

export const RTISpecificationStyles = styled.section``;
